export const environment = {
	production: true,
	apiUrl: "https://proxy-13330891459.europe-west1.run.app",
	apiUrlFormio: 'https://proxy-13330891459.europe-west1.run.app',
	firebaseConfig: {
		apiKey: 'AIzaSyBUt8jjSyTi1oNHS5W8lonV-QISpOfWn6U',
		authDomain: 'origamee-prod.firebaseapp.com',
		projectId: 'origamee-prod',
		storageBucket: 'origamee-prod.appspot.com',
		messagingSenderId: '13330891459',
		appId: '1:13330891459:web:f56649d87162b5a2829876',
		measurementId: 'G-S6T2E9SJBK',
		vapidKey:'BO4uvy6KJ96JRJnE6owv9VxAOIGGD0cTp6pueVvcYeyyC_C8p2TvCqUk9jiXJBBYNLEC4SoFLS53jKZy8YL1SCA'
	},
	imagesUrl: "https://storage.googleapis.com/origamee-prod-public/",
	recaptcha: {
		siteKey: '6LdupU0gAAAAADusMvTiYJpAC_Q9a2CaEWDgk7Os',
	}
};
